module.exports = __webpack_public_path__ + "static/media/dec-tendency.7bb45907.svg";